<script>
</script>

<style>
    .footer {
        font-size: 1rem;
        line-height: 1.5;
        padding-top: 3rem;
        padding-bottom: 3rem;
        min-height: 10vh;
        /* font-family: "Helvetica Neue", helvetica, arial, sans-serif; */
        font-family: "Apercu", sans-serif;
        margin: 0 auto 0 auto;

        width: 50rem;
        max-width: 55vw;  
    }
    @media screen and (max-width: 900px) {
        .footer {
            min-height: calc(100vh - 6rem);
            max-width: 83vw;
        }
    }

    @media only screen and  (max-width: 360px) {
        .footer p {
            font-size: 12px;
        }
    }

    .footer a {
        text-decoration: none;
    }

    .footer-section {
        margin-bottom: 2rem;
    }

    /* .footer hr {
        margin-bottom: 2rem;
    } */

    a {
        color: #03B5AA; 
        /* rgb(113, 177, 240) */
    }

</style>

<div class={"footer"}>
    <!-- <hr /> -->
    <div class="footer-section">
        <h1> Ahoy, traveler!</h1>
        <p>
            Thank you for reaching the bottom of this page. Here are some easter eggs:
        </p>
        <p>
            💡 This footer is the average of all dominant colors in the dataset!
        </p>
        <p>
            💡 The images on the top of this page reshuffle when you refresh the page.
        </p>
        <p>
            This work is a labor of ❤️ by Olivia Seow, with credits to <a target="_blank" href="https://arxiv.org/abs/2006.06676">NV Labs</a>, <a target="_blank" href="https://github.com/Rich-Harris">Rich Harris</a>, <a target="_blank" href="https://github.com/sdl60660">Sam Learner</a>, and <a target="_blank" href="https://github.com/dvschultz">Derrick Schultz</a> for the data and code references. The GitHub repo is <a target="_blank" href="https://github.com/oliviaseow/metAI">here</a>.
        </p>
        
    </div>
</div>